(() => {
  if (customElements.get('listing-recommendations')) return;

  // The existing recommendations element replaces its contents after its fetch.
  // Keep its controller outside that lifecycle and discover the current track.
  class ListingRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      this.addEventListener('scroll', this.schedule, { capture: true, passive: true });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this, { childList: true, subtree: true });
      this.sizeObserver = new ResizeObserver(this.schedule);
      this.sizeObserver.observe(this);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.sizeObserver?.disconnect();
      this.removeEventListener('scroll', this.schedule, true);
      cancelAnimationFrame(this.frame);
      this.observer = this.sizeObserver = this.track = null;
      this.frame = 0;
    }

    update() {
      const track = this.querySelector('.products.row');
      const progress = this.querySelector('[data-listing-recommendation-progress]');
      const thumb = this.querySelector('[data-listing-recommendation-thumb]');
      if (this.track !== track) {
        if (this.track) this.sizeObserver.unobserve(this.track);
        this.track = track;
        if (track) this.sizeObserver.observe(track);
      }
      if (!track || !progress || !thumb) return;
      const count = track.children.length;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const visible = matchMedia('(max-width: 767px)').matches && count > 1 && maxScroll > 1;
      progress.hidden = !visible;
      if (!visible) return;
      const portion = 1 / count;
      const position = Math.min(1, Math.max(0, Math.abs(track.scrollLeft) / maxScroll));
      thumb.style.width = portion * 100 + '%';
      thumb.style.left = position * (1 - portion) * 100 + '%';
    }
  }

  customElements.define('listing-recommendations', ListingRecommendations);
})();
